import { createReducer, on } from '@ngrx/store';
import { saveLocations } from './locations.actions';

export const saveLocationsReducer = (_: any, { value }: { value: any }): any =>
    value;

export const LocationsReducer = createReducer(
    [],
    on(saveLocations, saveLocationsReducer),
);
